import { ArtistExpenseTag, VenueExpenseTag } from "@quantizr-engineering/common/types/show";

export const getExpenseTagsToCategories = (
  category: string,
  tag: VenueExpenseTag | ArtistExpenseTag | undefined
) => {
  if (!tag) return false;

  const categoryMappings: Record<string, string[]> = {
    Crew: ["Crew"],
    Hospitality: ["Catering", "Hospitality", "Meal Buyouts", "Per Diem"],
    Marketing: [
      "Advertising",
      "Marketing",
      "Promotional",
      "Publicity",
      "Video & Photo",
    ],
    Miscellaneous: [
      "Licenses",
      "Miscellaneous",
      "Cancellation Insurance",
      "Insurance",
      "Show Insurance",
      "Auto Insurance",
      "Liability Insurance",
      "Travel Insurance",
      "Insurance (Other)",
    ],
    Production: [
      "Backline",
      "Barricade",
      "Lighting",
      "Production (Other)",
      "Runner & Vans",
      "SFX",
      "Video",
      "Shuttle Trucks",
      "Sound",
      "Staging",
      "Production (General)",
      "Lasers",
      "Equipment Rental",
    ],
    Staffing: [
      "Box Office",
      "Cleanup",
      "Fire/Medical",
      "Police",
      "Security",
      "Staffing",
      "Stagehands",
      "Ticket Takers",
      "Ushers",
    ],
    Support: ["Support"],
    "Tour Transportation": [
      "Bus Rental",
      "Van Rental",
      "Bus/Van Gas",
      "Trucking",
    ],
    "Tour Supplies": ["Tour Supplies"],
    Travel: [
      "Travel (Other)",
      "Baggage Fees",
      "Car Rental",
      "Flights",
      "Gas",
      "Hotels",
      "Parking",
      "Rideshare Taxi",
      "Public Transportation",
    ],
    Variable: ["Variable (Other)", "ASCAP", "BMI", "GMR", "SESAC"],
    Venue: ["House Nut", "Rent", "Venue", "Barricade", "Seating"],
  };

  return categoryMappings[category]?.includes(tag) || false;
};

export const stringLengthLimiter = (str: string, limit: number) => {
  if (!str) return "";
  return str.length > limit ? str.substring(0, limit) + "..." : str;
};

export const greaterOfNumbers = (numbers: number[]) => {
  if (!numbers || numbers.length === 0) return 0;
    return Math.max(...numbers);
  
}
